import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)`
	color: inherit !important;
	text-decoration: none !important;
	display: block;
	width: 100%;
	padding: 0.5rem 1.25rem;

	&:hover {
		background-color: #e9ecef;
		color: inherit !important;
	}
`;
